module.exports = __webpack_public_path__ + "img/tijiaochenggongen.238158c5.jpg";